import {useQueryString} from 'utils/useQueryString'
import {z} from 'zod'

export const useQueryStringOpened = (key: string, options?: {onOpen?: () => void; onClose?: () => void}) => {
  const qs = useQueryString(z.object({[key]: z.boolean().optional()}))
  const setOpened = (opened: boolean) => {
    qs.setQuery(opened ? {[key]: true} : {[key]: undefined})
    if (opened) options?.onOpen?.()
    else options?.onClose?.()
  }
  const opened = qs.query[key] ?? false
  return {
    opened,
    setOpened,
    close: () => setOpened(false),
    open: () => setOpened(true),
    toggle: () => setOpened(!opened)
  }
}
